import React, { useEffect, useRef, useState } from 'react'
import Header from '../../component/Header';
import { Link } from 'react-router-dom';


export default function OurExperts(props) {
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const togglePlayPause = () => {
        if (videoRef.current.paused) {
            videoRef.current.play();
            setIsPlaying(true);
        } else {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    };

    return (
        <>
            <Header />
            <section className='banner-section-about top bottom p-l-r'>
                <div className='about-banner-content'>
                    {/* <img src={require('../../assets/images/frame1.png')} /> */}
                    <h1 className='about-page-heading'>
                        We’ve brought together top experts from the wellness industry to guide and support you across all 5 dimensions of wellbeing.
                    </h1>
                </div>
            </section>
            <section className='experts-section bottom p-l-r'>
                <div className='container-fluid'>
                    <div className='row justify-content-center'>
                        <div className='col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4'>
                            <div className='experts-section-box'>
                                <div className='experts-section-child'>
                                    <ul>
                                        <li>Nutritionist</li>
                                        <li>Healer</li>
                                        <li>Mindset Re-engineering Coach</li>
                                        <li>Mental Health Advocate</li>
                                        <li>Ayurvedic Consultant</li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4'>
                            <div className='experts-section-box'>
                                <div className='experts-section-child'>
                                    <ul>
                                        <li>Mental Health Counsellor</li>
                                        <li>Astrologer</li>
                                        <li>Life Coach</li>
                                        <li>Spiritual Teacher</li>
                                        <li>Health and Fitness Coach</li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4'>
                            <div className='experts-section-box'>
                                <div className='experts-section-child'>
                                    <ul>
                                        <li>Spiritual Life Coach</li>
                                        <li>Kids and Parents life coach</li>
                                        <li>Family Therapist</li>
                                        <li>Medical Astrologer</li>
                                        <li>Child Psychologist</li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4'>
                            <div className='experts-section-box'>
                                <div className='experts-section-child'>
                                    <ul>
                                        <li>Vedic Astrologer</li>
                                        <li>Yoga &Pilates Coach</li>
                                        <li>Stress Coach</li>
                                        <li>Parental Therapist</li>
                                        <li>Functional Medical Consultant</li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4'>
                            <div className='experts-section-box'>
                                <div className='experts-section-child'>
                                    <ul>
                                        <li>Reiki Healer</li>
                                        <li>Ayurvedic Cosmetologist</li>
                                        <li>Leadership Success Coach</li>
                                        <li>Emotional Intelligence Coach</li>
                                        <li>Psychologist</li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4'>
                            <div className='experts-section-box'>
                                <div className='experts-section-child'>
                                    <ul>
                                        <li>Vastu-FengShui Expert</li>
                                        <li>Periodontist and Oral Implantologist</li>
                                        <li>Therapist and Wellness Coach</li>
                                        <li>Menstrual Health Facilitator</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='experts-section bottom p-l-r d-none'>
                <div className='container-fluid'>
                    <div className='row justify-content-center'>

                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_1'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Nutritionist</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_2'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Healer</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_3'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Mindset Re-engineering Coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_4'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Mental Health Advocate</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_5'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Ayurvedic Consultant</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_1'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Vastu-FengShui Expert</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_2'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Mental Health Counsellor</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_3'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Astrologer</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_4'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Life Coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_5'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Spiritual Teacher</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_1'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Health and Fitness Coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_2'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Periodontist and Oral Implantologist</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_3'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Spiritual Life Coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_4'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Kids and Parents life coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_5'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Family Therapist</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_1'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Medical Astrologer</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_2'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Child Psychologist</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_3'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Therapist and Wellness Coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_4'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Vedic Astrologer</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_5'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Yoga &Pilates Coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_1'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Stress Coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_2'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Parental Therapist</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_3'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Functional Medical Consultant</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_4'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Menstrual Health Facilitator</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_5'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Reiki Healer</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_1'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Ayurvedic Cosmetologist</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_2'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Leadership Success Coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_3'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Emotional Intelligence Coach</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 p-0'>
                            <div className='experts-box bg_4'>
                                <img src={require('../../assets/images/frame1.png')} />
                                <div className='experts-content-box'>
                                    <h4>Phycologist</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='expert-help bottom top p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-5 order_2'>
                            <div className='left-section'>
                                <div className='left-section-video'>
                                    {/* <button onClick={togglePlayPause} type='button' className='play_btn_box'>
                                        {
                                            isPlaying ? <i class="fa-solid fa-pause"></i> : <i class="fa-solid fa-play"></i>
                                        }
                                    </button> */}
                                    <video ref={videoRef} poster={require('../../assets/images/MULTIPLE-SLIDE-REEL _1.jpg')} className=""
                                        autoPlay
                                        muted
                                        playsInline
                                        loop
                                        src="https://static.thebeyondlifestyle.com/man-woman-doing-yoga-together-outdoors.jpg"></video>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6 order_1'>
                            <div className='right-section'>
                                <div class="mental-health-content">
                                    <h3 class="heading2 text_gradient_2">
                                        Expert Help at Your Finger Tips
                                    </h3>
                                </div>
                                <p className='paragraph'>Wellbeing isn’t a universal formula — we believe it should be personalized to suit each individual’s unique needs.</p>
                                <p className='paragraph'>We are looking forward for you to Unlock your wellness journey with an expert with just a click. Book Your First free <span style={{ textDecorationLine: 'underline' }}>Talk To Me</span> Session Today.</p>
                                <p className='paragraph last_p'>Do what it actually takes to be happier!</p>
                                <Link to='/plans' className='common_btn'>Try for Free <i class="fa-solid fa-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='our-expert-collage top bottom'>
                <img src="https://static.thebeyondlifestyle.com/man-woman-doing-yoga-together-outdoors.jpg" />
                <div className='our-expert-box'>
                    <h3>Mindfulness is a Journey</h3>
                    <div className='our-expert-collage-box'>
                        <div className='left-our-expert-collage'>
                            <h5><span>For</span><br /> individuals</h5>
                            <Link to='/services/individuals' className='common_btn'><i class="fa-solid fa-arrow-right"></i></Link>
                        </div>
                        <div className='left-our-expert-collage'>
                            <h5><span>For</span><br /> Companies</h5>
                            <Link to='/services/companies' className='common_btn'><i class="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                    <Link to='/plans' className='common_btn'>Explore Now<i class="fa-solid fa-arrow-right"></i></Link>
                </div>
            </section>
        </>
    )
}
